(function () {
  var runtimeVersion = '2.1.0';

  if (window.multiContent && window.multiContent.runtimeVersion === runtimeVersion) {
    window.multiContent.init(document);
    return;
  }

  var videoAutoplay = (function () {
    var observer;
    var preloadObserver;
    var pageEventsBound = false;
    var activeVideo = null;

    function removeVideoPoster(video) {
      var videoSection = video.closest('video-section');
      var poster = videoSection ? videoSection.querySelector('.video-poster-wrapper') : null;
      if (poster) {
        poster.style.display = 'none';
      }
      if (videoSection) {
        videoSection.classList.add('is-playing');
      }
    }

    function restoreVideoPoster(video) {
      var videoSection = video.closest('video-section');
      var poster = videoSection ? videoSection.querySelector('.video-poster-wrapper') : null;
      if (poster) {
        poster.style.display = '';
      }
      if (videoSection) {
        videoSection.classList.remove('is-playing');
      }
    }

    function loadVideoSources(video) {
      if (!video) return false;
      if (video.dataset.mcLoaded === 'true') return true;

      if (video.querySelector('source[src]')) {
        video.dataset.mcLoaded = 'true';
        return true;
      }

      var videoSection = video.closest('video-section');
      var sourceTemplate = videoSection ? videoSection.querySelector('[data-mc-video-sources]') : null;
      if (!sourceTemplate) return false;

      if (video.dataset.poster) {
        video.poster = video.dataset.poster;
      }
      video.append(sourceTemplate.content.cloneNode(true));
      video.dataset.mcLoaded = 'true';
      video.load();
      return true;
    }

    function getVideoVisibilityElement(video) {
      var videoSection = video ? video.closest('video-section') : null;
      return videoSection || video;
    }

    function isVideoVisible(video) {
      if (!video || !video.isConnected) return false;

      var visibilityElement = getVideoVisibilityElement(video);
      if (!visibilityElement) return false;

      var rect = visibilityElement.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      return rect.bottom > 0 && rect.right > 0 && rect.top < viewportHeight && rect.left < viewportWidth;
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 767.98px)').matches;
    }

    function pauseOtherAutoplayVideos(currentVideo) {
      if (!isMobileViewport()) return;

      document.querySelectorAll('.sec__multi-content video[data-mc-autoplay="true"]').forEach(function (video) {
        if (video !== currentVideo && !video.paused) {
          video.pause();
        }
      });
    }

    function pauseAutoplayVideo(video) {
      if (!video) return;
      video.removeAttribute('autoplay');
      if (!video.paused) video.pause();
      if (activeVideo === video) activeVideo = null;
    }

    function requestAutoplay(video) {
      if (!video || video.dataset.mcAutoplay !== 'true') return;
      if (!isVideoVisible(video)) return;

      if (isMobileViewport() && activeVideo && activeVideo !== video) {
        if (isVideoVisible(activeVideo) && !activeVideo.paused && !activeVideo.ended) {
          return;
        }

        activeVideo = null;
      }

      if (!video.paused && !video.ended) {
        activeVideo = video;
        removeVideoPoster(video);
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('preload', 'auto');
      if (!loadVideoSources(video)) return;

      if (video.readyState === 0 && video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
        try {
          video.load();
        } catch (error) {}
      }

      var playPromise;
      try {
        playPromise = video.play();
      } catch (error) {
        return;
      }

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            if (!isVideoVisible(video)) {
              video.pause();
              return;
            }
            activeVideo = video;
            pauseOtherAutoplayVideos(video);
            removeVideoPoster(video);
          })
          .catch(function () {});
      }
    }

    function retryVisibleVideos() {
      document.querySelectorAll('.sec__multi-content video[data-mc-autoplay="true"]').forEach(function (video) {
        if (isVideoVisible(video)) {
          requestAutoplay(video);
        }
      });
    }

    function ensureObserver() {
      if (observer || !('IntersectionObserver' in window)) return;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.matches('video')
              ? entry.target
              : entry.target.querySelector('video[data-mc-autoplay="true"]');
            if (!video) return;

            if (entry.isIntersecting) {
              requestAutoplay(video);
              return;
            }

            pauseAutoplayVideo(video);
          });
        },
        {
          threshold: 0.01,
          rootMargin: '0px',
        }
      );
    }

    function ensurePreloadObserver() {
      if (preloadObserver || !('IntersectionObserver' in window)) return;

      preloadObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            var video = entry.target.matches('video')
              ? entry.target
              : entry.target.querySelector('video[data-mc-autoplay="true"]');
            if (!video) return;

            video.setAttribute('preload', 'auto');
            loadVideoSources(video);
            try {
              video.load();
            } catch (error) {}
            preloadObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0,
          // Start buffering roughly one viewport ahead without allowing playback before intersection.
          rootMargin: '800px 0px',
        }
      );
    }

    function bindPageEvents() {
      if (pageEventsBound) return;
      pageEventsBound = true;

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          document.querySelectorAll('.sec__multi-content video[data-mc-autoplay="true"]').forEach(function (video) {
            pauseAutoplayVideo(video);
          });
          activeVideo = null;
          return;
        }

        retryVisibleVideos();
      });

      window.addEventListener('pageshow', function () {
        retryVisibleVideos();
      });

      window.addEventListener('focus', function () {
        retryVisibleVideos();
      });
    }

    function prepareAutoplayVideo(video) {
      if (video.dataset.mcAutoplayBound === 'true') return;
      video.dataset.mcAutoplayBound = 'true';

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'none');

      video.addEventListener('playing', function () {
        if (!isVideoVisible(video)) {
          video.pause();
          return;
        }
        activeVideo = video;
        pauseOtherAutoplayVideos(video);
        removeVideoPoster(video);
      });

      video.addEventListener('pause', function () {
        if (activeVideo === video) {
          activeVideo = null;
        }
      });

      video.addEventListener('ended', function () {
        if (activeVideo === video) {
          activeVideo = null;
        }
      });

      ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          requestAutoplay(video);
        });
      });

      ['stalled', 'suspend', 'waiting'].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          window.setTimeout(function () {
            if (isVideoVisible(video)) {
              requestAutoplay(video);
            }
          }, 120);
        });
      });

      if (observer) {
        var visibilityElement = getVideoVisibilityElement(video);
        observer.observe(visibilityElement);
        if (preloadObserver) preloadObserver.observe(visibilityElement);
      } else if (isVideoVisible(video)) {
        requestAutoplay(video);
      }
    }

    function init(root) {
      bindPageEvents();
      ensureObserver();
      ensurePreloadObserver();

      var scope = root || document;
      var videos = scope.querySelectorAll('.sec__multi-content video[data-mc-autoplay="true"]');
      videos.forEach(prepareAutoplayVideo);
    }

    return {
      init: init,
      loadVideoSources: loadVideoSources,
      removeVideoPoster: removeVideoPoster,
      restoreVideoPoster: restoreVideoPoster,
    };
  })();

  function initAccordions(root) {
    var scope = root || document;

    function getBody(item) {
      return item ? item.querySelector('.mc-accordion__body') : null;
    }

    function syncInitialState(item) {
      var body = getBody(item);
      var button = item.querySelector('.mc-accordion__toggle');
      var isOpen = item.classList.contains('is-open');

      if (body) {
        body.style.height = isOpen ? 'auto' : '';
        body.style.overflowY = '';
      }

      if (button) {
        button.setAttribute('aria-expanded', String(isOpen));
      }
    }

    function openItem(item) {
      var body = getBody(item);
      var button = item.querySelector('.mc-accordion__toggle');

      item.classList.add('is-open');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (!body) return;

      body.dataset.mcAccordionState = 'opening';
      body.style.overflowY = 'hidden';
      body.style.height = '0px';
      body.offsetHeight;
      body.style.height = body.scrollHeight + 'px';
    }

    function closeItem(item) {
      var body = getBody(item);
      var button = item.querySelector('.mc-accordion__toggle');

      if (button) button.setAttribute('aria-expanded', 'false');
      if (!body) {
        item.classList.remove('is-open');
        return;
      }

      body.dataset.mcAccordionState = 'closing';
      body.style.overflowY = 'hidden';
      body.style.height = body.scrollHeight + 'px';
      body.offsetHeight;
      item.classList.remove('is-open');
      body.style.height = '0px';
    }

    function bindItemTransition(item) {
      syncInitialState(item);
      var body = getBody(item);
      if (!body || body.dataset.mcAccordionTransitionBound) return;

      body.dataset.mcAccordionTransitionBound = 'true';
      body.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'height') return;

        if (body.dataset.mcAccordionState === 'opening' && item.classList.contains('is-open')) {
          body.style.height = 'auto';
          body.style.overflowY = '';
        }

        if (body.dataset.mcAccordionState === 'closing' && !item.classList.contains('is-open')) {
          body.style.height = '';
          body.style.overflowY = '';
        }

        body.dataset.mcAccordionState = '';
      });
    }

    scope.querySelectorAll('.mc-accordion__item').forEach(bindItemTransition);

    if (scope.dataset.mcAccordionDelegated === 'true') return;
    scope.dataset.mcAccordionDelegated = 'true';
    scope.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('.mc-accordion__toggle');
      if (!button || !scope.contains(button)) return;
      if (button.dataset.mcAccordionBound === 'true') return;

      var item = button.closest('.mc-accordion__item');
      var accordion = item ? item.closest('.mc-accordion') : null;
      var isOpen = item && item.classList.contains('is-open');

      if (!item || !accordion || !scope.contains(accordion)) return;
      bindItemTransition(item);

      accordion.querySelectorAll('.mc-accordion__item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          bindItemTransition(openItem);
          closeItem(openItem);
        }
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  }

  function initVideoClickToPlay(root) {
    var scope = root || document;
    var videoSections = scope.querySelectorAll('.sec__multi-content video-section');

    function playVideo(video) {
      if (!video || (!video.paused && !video.ended)) return;

      if (!videoAutoplay.loadVideoSources(video)) return;
      video.setAttribute('preload', 'auto');
      videoAutoplay.removeVideoPoster(video);

      try {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(function () {
              videoAutoplay.removeVideoPoster(video);
            })
            .catch(function () {
              videoAutoplay.restoreVideoPoster(video);
            });
        }
      } catch (error) {
        videoAutoplay.restoreVideoPoster(video);
      }
    }

    videoSections.forEach(function (videoSection) {
      var video = videoSection.querySelector('video');
      if (!video || videoSection.dataset.mcVideoClickBound === 'true') return;

      videoSection.dataset.mcVideoClickBound = 'true';
      videoSection.style.cursor = 'pointer';

      video.addEventListener('playing', function () {
        videoAutoplay.removeVideoPoster(video);
      });

      videoSection.addEventListener('click', function (event) {
        if (event.target.closest('video')) {
          if (video.hasAttribute('controls')) return;
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }
        }
        playVideo(video);
      });

      var poster = videoSection.querySelector('.video-poster-wrapper');
      if (poster) {
        poster.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          playVideo(video);
        });
        poster.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          playVideo(video);
        });
      }
    });
  }

  function initSection(section) {
    if (!section) return;
    section.dataset.multiContentInitialized = 'true';

    var scope = section;
    videoAutoplay.init(scope);
    initVideoClickToPlay(scope);
    initAccordions(scope);
  }

  var sectionInitObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initSection(entry.target);
        });
      }, { rootMargin: '700px 0px' })
    : null;

  function init(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('.sec__multi-content')) {
      sections.push(scope);
    }
    if (scope.querySelectorAll) {
      sections = sections.concat(Array.from(scope.querySelectorAll('.sec__multi-content')));
    }

    sections.forEach(function (section) {
      if (section.dataset.multiContentInitialized === 'true') {
        initSection(section);
        return;
      }
      if (!sectionInitObserver) {
        initSection(section);
        return;
      }
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < viewportHeight + 700 && rect.bottom > -700) {
        initSection(section);
        return;
      }
      sectionInitObserver.observe(section);
    });
  }

  window.multiContent = {
    runtimeVersion: runtimeVersion,
    init: init,
    videoAutoplay: videoAutoplay,
  };
  window.multiContentVideoAutoplay = videoAutoplay;

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('theme:assets:ready', function (event) {
    var section = event.target.closest('.shopify-section') || event.target.parentElement;
    init(section);
  });

  init(document);
})();
